import React from 'react';
import styled from 'styled-components';
import { Spacing24 } from 'autogen/design-tokens/tokens';
import { Body } from 'components/generic/typography';
import quickView from 'components/quickView';
import { breakpoint, sizes } from 'variables';

const StyledQuickview = styled(quickView)`
    padding: ${Spacing24};

    ${breakpoint.up(sizes.sm)} {
        max-width: 320px;
    }
`;

export default function ReviewComplianceQuickview({ complianceText }) {
    return (
        <StyledQuickview quickViewId="ReviewComplianceQuickview">
            <Body size="M" dangerouslySetInnerHTML={{ __html: complianceText }} />
        </StyledQuickview>
    );
}
